import * as angular from 'angular';
import * as _ from 'underscore';

export interface IAutocompletedModel {
    autocompletedData: (search?: any) => ng.IPromise<Array<IAutocompleteResponse>>;
    autocompletedInitData: () => ng.IPromise<Array<IAutocompleteResponse>>;
}

export class IAutocompleteResponse {
    Value: string;
    Highlighted: string;
}

function autocompleted(): ng.IDirective {
    return {
        require: 'ngModel',
        restrict: 'A',
        scope: {
            autocompletedData: '&',
            autocompletedInitData: '&'
        },
        link: function (scope: ng.IScope & IAutocompletedModel, element: JQLite, attr: ng.IAttributes, ctrl: ng.IController) {
            var currentFocus;
            var defaultData = [];

            function addActive(x: any) {
                if (!x) { return false; }
                removeActive(x);
                if (currentFocus >= x.length) { currentFocus = 0; }
                if (currentFocus < 0) { currentFocus = (x.length - 1); }

                x[currentFocus].classList.add('autocomplete-active');
            }
            function removeActive(x: any) {
                for (var i = 0; i < x.length; i++) {
                    x[i].classList.remove('autocomplete-active');
                }
            }
            function closeAllLists(elmnt?: any) {
                var x = document.getElementsByClassName('autocomplete-items');
                for (var i = 0; i < x.length; i++) {
                    if (elmnt !== x[i] && elmnt !== element) {
                        x[i].parentNode.removeChild(x[i]);
                    }
                }
            }
            function getIndex(index: any) {
                return function() {
                    return index;
                };
            }
            function renderList(data: Array<IAutocompleteResponse>, searchString: string, context: any) {
                closeAllLists();

                if (data instanceof Array && data.length === 0) {
                    return;
                }

                if (!searchString) { data = defaultData; }
                currentFocus = -1;
                var listDomElement = document.createElement('DIV');
                listDomElement.setAttribute('id', context.id + 'autocomplete-list');
                listDomElement.setAttribute('class', 'autocomplete-items');
                context.parentNode.appendChild(listDomElement);

                for (var i = 0; i < data.length; i++) {
                    var listItemDomElement = document.createElement('DIV');
                    listItemDomElement.innerHTML = data[i].Highlighted;

                    let getIndexClosure = getIndex(i);
                    listItemDomElement.addEventListener('click', function(e: any) {
                        let index = getIndexClosure();
                        ctrl.$setViewValue(data[index].Value);
                        ctrl.$render();
                        e.preventDefault();
                        scope.$apply();
                        closeAllLists();
                    });
                    listDomElement.appendChild(listItemDomElement);
                }
            }
            element.bind('input', function() {
                var val = this.value;
                if (!val) {
                    renderList(defaultData, '', this);
                    return;
                }
                scope.autocompletedData({search: val}).then((data: Array<IAutocompleteResponse>) => {
                    renderList(data, val, this);
                });
            });
            element.bind('keydown', function(e: any) {
                var x = document.getElementById(this.id + 'autocomplete-list');
                if (x) { (<any>x) = x.getElementsByTagName('div'); }
                if (e.keyCode === 40) {
                    /* Arrow down */
                    currentFocus++;
                    addActive(x);
                } else if (e.keyCode === 38) {
                    /* Arrow up */
                    currentFocus--;
                    addActive(x);
                } else if (e.keyCode === 27) {
                    /* Esc */
                    closeAllLists();
                } else if (e.keyCode === 13) {
                    /* Enter */
                    e.preventDefault();
                    if (currentFocus > -1) {
                        if (x) { x[currentFocus].click(); }
                    }
                }
            });
            element.bind('focusin', function(e: any) {
                if (!this.value) {
                    closeAllLists();
                    renderList(defaultData, '', this);
                }
            });
            element.bind('blur', function(e: any) {
                setTimeout(() => {
                    closeAllLists();
                }, 200);
            });
            scope.autocompletedInitData().then((arr) => {
                defaultData = arr;
            });
        }
    };
}

angular
    .module('app.common')
    .directive('autocompleted', autocompleted);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.common/modules/common/directives/autocompleted.directive.ts